/*
 *  Copyright (c) Pro3W 2025
 *  author: Sławomir Moskal
 *  project: dev.cms.pro3w.pl
 *  filename: js_aos.js
 *  last update: 18.01.2025, 23:45
 */

// import "aos"; ta bibliotek apowoduje ponowne wczytanie jquery - do weryfikacji
import AOS from '@dartmoon/aos-responsive'

AOS.init({
  // You AOS configs
})
window.AOS = AOS;
